import React from 'react';
import { compose } from 'ramda';
import { reduxForm, InjectedFormProps, Field, Form } from 'redux-form';
import FormHelperText from '@material-ui/core/FormHelperText';
import { makeStyles } from '@material-ui/core/styles';

import Fields from 'components/Fields';
import Button from 'components/Button/Button';
import IntlProvider, {
  useFormatMessage,
  IntlProviderType,
} from 'components/IntlProvider';

export interface ProfileValuesTypes {
  [key: string]: string;
}

const useStyles = makeStyles((theme) => ({
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  nonEditableBox: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid black',
    borderRadius: '4px',
    color: 'black',
    padding: '18.5px 14px',
    lineHeight: '1rem',
  },
  nonEditableLabel: {
    position: 'absolute',
    transform: 'translate(-6px, -9px) scale(0.75)',
    backgroundColor: 'white',
    padding: '0 9px',
    top: 0,
    left: 0,
  },
  nonEditableSpan: {
    overflow: 'hidden',
  },
}));

const validate = (
  values: { [key: string]: string },
  { intl }: { intl: IntlProviderType }
) => {
  const errors: { [key: string]: string } = {};
  if (!values.email) {
    errors.email = intl.formatMessage({
      id: 'errors.fields.required',
      defaultMessage: 'Field is required',
    });
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = intl.formatMessage({
      id: 'errors.fields.email.format',
      defaultMessage: 'Invalid email format',
    });
  }
  return errors;
};

const InviteUser = ({ handleSubmit, error, submitting }: InjectedFormProps) => {
  const classes = useStyles();
  const t = useFormatMessage();
  return (
    <Form onSubmit={handleSubmit} className={classes.form} noValidate>
      <Field
        component={Fields.Text}
        variant="outlined"
        fullWidth
        multiline
        rows="8"
        helperText={t(
          'forms.inviteuser.helpertext',
          'Separate e-mail addresses with a comma'
        )}
        name="emails"
        label={t('forms.inviteuser.email', 'Provide email addresses')}
        placeholder="mail@domain.com,mail2@domain.com"
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
        isLoading={submitting}
      >
        {t('forms.inviteuser.invite', 'Invite users')}
      </Button>
    </Form>
  );
};

export default compose(
  IntlProvider.withIntl,
  reduxForm({
    form: 'inviteUser',
    validate,
  })
)(InviteUser);
